import { render, staticRenderFns } from "./customer-detail-follow.vue?vue&type=template&id=cdcb350c&scoped=true"
import script from "./customer-detail-follow.vue?vue&type=script&lang=js"
export * from "./customer-detail-follow.vue?vue&type=script&lang=js"
import style0 from "./customer-detail-follow.vue?vue&type=style&index=0&id=cdcb350c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdcb350c",
  null
  
)

export default component.exports